import { render } from "./CornerTile.vue?vue&type=template&id=2a6f0dfa&scoped=true"
import script from "./CornerTile.vue?vue&type=script&lang=js"
export * from "./CornerTile.vue?vue&type=script&lang=js"

import "./CornerTile.vue?vue&type=style&index=0&id=2a6f0dfa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6f0dfa"]])

export default __exports__